<template>
  <div class="home">
    <!-- 顶部 -->
    <Tab :kexs="3"></Tab>
    <!-- body -->
    <div class="body"><!-- 未认证提示 -->
      <div class="NotCertified" v-if="status == -1">
        <div>检测到您还未登录，请登录</div>
        <div class="NotCertified-box" @click="page('Login')">立即登录</div>
      </div>
      <!-- 未认证提示 -->
      <div class="NotCertified" v-else-if="status == 3">
        <div>检测到您还未进行商家认证，请前往认证中心认证</div>
        <div class="NotCertified-box" @click="page('Paimaijigou')">立即前往</div>
      </div>
      <!-- 认证成功提示 -->
      <div class="NotCertified" v-if="status == 1">
        <div style="color:#07C160">您已认证成功</div>
      </div>
      <!-- 认证失败提示 -->
      <div class="NotCertified" v-if="status == 2">
        <div>检测到您的商家认证失败，请前往认证中心修改</div>
        <div class="NotCertified-box" @click="page('Paimaijigou')">立即前往</div>
      </div>
      <!-- 审核中提示 -->
      <div class="NotCertified" v-if="status == 0">
        <div style="color:#FF7C00">您的商家认证正在审核，请耐心等待</div>
      </div>
      <!-- 认证商家 -->
      
            <el-empty v-if="shopList.length == 0" description="暂时没有数据哦~"></el-empty>
      <div class="business pointer">
        <div class="business-box" @click="handlePage(item.id)" v-for="(item, index) in shopList" :key="index">
          <div class="business-box-top">
            <div class="business-box-ava">
              <img :src="item.image_text" @error="errorImg" alt="" />
            </div>
            <div class="business-box-name">{{item.name}}</div>
            <div class="business-box-text">{{item.enterprisename}}</div>
          </div>
          <div class="business-box-btn">
            <div class="business-box-bts">
              <div class="business-box-img">
                <img src="../../assets/image/chengjiao.png" alt="" />
              </div>
              <div class="business-box-text1">累计成交</div>
              <div class="business-box-text2">{{item.ccounts}}</div>
            </div>
            <div class="business-box-bts">
              <div class="business-box-img">
                <img src="../../assets/image/shuliang.png" alt="" />
              </div>
              <div class="business-box-text1">商品数量</div>
              <div class="business-box-text2">{{item.zcounts}}</div>
            </div>
          </div>
          <div class="business-box-rz">已认证</div>
        </div>

        <!-- 分页 -->
        <div class="page page1">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="12"
            layout="prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
          <div class="pointer tz">跳转</div>
        </div>
        <div class="page page2">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage3"
            :page-size="12"
            layout="prev, pager, next"
            :total="total"
            small
          >
          </el-pagination>
        </div>
      </div>
      <!-- 保障 -->
      <Guarantee></Guarantee>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Tab from "@/components/tab.vue";
import Footer from "@/components/footer.vue";
import Guarantee from "@/components/Guarantee.vue";
export default {
  name: "Business",
  data() {
    return {
      currentPage3: 1, //默认分页
      total:1,
      shopList:[], // 商家列表
      status:3 ,//认证状态 0=待审核,1=审核通过,2=审核失败,3=提交
    };
  },
  mounted() {
    // 已认证商家列表
    this.$apis.getshoplist().then((res) => {
      this.shopList = res.data.data
      this.total = res.data.total
    })
    if(!localStorage.getItem('token')){
      this.status = -1
    }else{
    // 获取商家认证状态
    this.$apis.getauthentications().then((res) => {
      this.status = res.data.status
    })
    }
  },

  components: {
    Tab,
    Footer,
    Guarantee,
  },
  methods: {
    errorImg(event) {
      this.$pk.errorImg(event);
    },
    page(e) {
      this.$router.replace({
        name: e,
        query: {
          id: 1,
        },
      });
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    // 跳商家详情
    handlePage(id){
      this.$router.push({
        name: 'Homepage',
        query:{
          id:id
        }
      });
    }
  },
};
</script>
<style scoped='scoped'>
img {
  width: 100%;
  height: 100%;
}
i {
  font-size: 18px;
}
.home {
  overflow-x: hidden;
  background-color: #f5f5f5;
}
.body {
  width: 1136px;
  margin: 0 auto;
  padding: 16px 0 0;
}
.NotCertified {
  background-color: #fff;
  padding: 11px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #c7171e;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.1);
}
.NotCertified-box {
  width: 96px;
  height: 34px;
  background: #c7171e;
  color: #fff;
  font-size: 16px;
  line-height: 34px;
  text-align: center;
  margin-left: 32px;
}
.business {
  margin: 24px 0;
  display: flex;
  /* justify-content: space-between; */
  flex-wrap: wrap;
}
.business-box {
  background-color: #fff;
  width: 24.1%;
  margin-bottom: 24px;
  margin-right: 1.2%;
  position: relative;
}
.business-box-rz {
  width: 80px;
  height: 29px;
  background: #18a2d6;
  border-radius: 15px 0px 0px 15px;
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 29px;
}
.business-box-top {
  text-align: center;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
}
.business-box-ava {
  width: 48px;
  height: 48px;
  margin: 0 auto;
}
.business-box-name {
  margin-top: 8px;
  font-size: 18px;
}
.business-box-text {
  margin-top: 8px;
  font-size: 14px;
  color: #999;
}
.business-box-btn {
  display: flex;
  padding: 40px 0;
}
.business-box-img {
  width: 32px;
  height: 32px;
  margin: 0 auto;
}
.business-box-bts {
  width: 50%;
  text-align: center;
  font-size: 16px;
}
.business-box-text1 {
  margin: 8px 0 12px 0;
  color: #999;
}
.business-box-text2 {
  font-weight: bold;
} /* 分页 */
.el-pagination >>> .el-pager li {
  padding: 0;
  margin: 0 4px;
}
.el-pagination >>> .el-pager li.active {
  background-color: #c7171e;
  color: #fff;
}
.tz {
  width: 69px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background: #ffffff;
  font-size: 14px;
  color: #999;
  border-radius: 4px;
  border: 1px solid #c0c4cf;
}
.page {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
}
.page2 {
  display: none;
}
@media only screen and (min-width: 991px) {
  .business-box:nth-child(4n) {
    margin-right: 0;
  }
}
@media screen and (min-width: 991px) and (max-width: 1160px) {
  .body {
    width: 98%;
    margin: 0 auto;
  }
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .body {
    width: 98%;
    margin: 0 auto;
  }
  .business-box {
    width: 30.7%;
    margin-right: 3.8%;
  }

  .business-box:nth-child(3n) {
    margin-right: 0;
  }
}
@media only screen and (max-width: 767px) {
  .body {
    width: 98%;
    margin: 0 auto;
    padding: 10px 0 0;
  }
  .business-box {
    width: 49.1%;
    margin-right: 1.8%;
  }
  .business-box:nth-child(2n) {
    margin-right: 0;
  }
  .NotCertified {
    font-size: 12px;
  }
  .NotCertified-box {
    width: 70px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
  .business-box-rz {
    width: 64px;
    height: 24px;
    line-height: 24px;
  }
  .business-box-btn {
    padding: 23px 0;
  }
  .page1 {
    display: none;
  }
  .page2 {
    display: flex;
  }
}
</style>
